import { getErrorMessage } from 'application/util/error.util';

import './calendar-edit-modal.style.sass';
import template from './calendar-edit-modal.tpl.pug';

class CalendarEditModalController {
    /* @ngInject */
    constructor($q, modalService, calendarService, categoryService, notificationService) {
        this.$q = $q;
        this.modalService = modalService;
        this.calendarService = calendarService;
        this.categoryService = categoryService;
        this.notificationService = notificationService;
    }

    $onInit() {
        this.existing = this.calendar && this.calendar.id;
        this.loading = true;
        this.accountsInput = this.formatAccounts(this.calendar.accounts);

        if (typeof this.calendar.useAutoForecasting === 'undefined') {
            this.calendar.useAutoForecasting = false;
        }

        return this.categoryService.getPalette().then((colors) => {
            this.colors = (colors || []).map((color) => ({ hex: color }));
            if (!this.calendar.color && this.colors.length > 0) {
                this.calendar.color = this.colors[0].hex;
            }
        }).catch((result) => {
            this.notificationService.showError(getErrorMessage(result, `We were not able to load the color palette. Please try again later.`));
        }).finally(() => {
            this.loading = false;
        });
    }

    formatAccounts(accounts) {
        if (!accounts || accounts.length === 0) {
            return '';
        }

        return accounts
            .map((account) => account && account.name)
            .filter((name) => !!name)
            .join('\n');
    }

    parseAccounts(accountsInput) {
        if (!accountsInput) {
            return [];
        }

        return accountsInput
            .split('\n')
            .map((account) => account.trim())
            .filter((account) => account.length > 0)
            .map((name) => ({ name }));
    }

    save() {
        this.calendar.accounts = this.parseAccounts(this.accountsInput);

        let promise = this.existing
            ? this.calendarService.update(this.calendar)
            : this.calendarService.create(this.teamId, this.calendar);

        return promise.then(this.close.bind(this)).catch((result) => {
            this.notificationService.showError(getErrorMessage(result, `We were not able to save the calendar.`));
        });
    }

    close(calendar) {
        return this.onClose({
            data: calendar
        });
    }

    dismiss() {
        return this.onDismiss();
    }
}

export default {
    selector: 'dbACalendarEditModal',
    template: template(),
    controller: CalendarEditModalController,
    bindings: {
        teamId: '<',
        calendar: '<',

        onDismiss: '&',
        onClose: '&'
    }
};



// WEBPACK FOOTER //
// ./src/application/component/modals/component/calendar-edit-modal/calendar-edit-modal.cmpt.js